export default __webpack_public_path__ + "static/media/6.6ef868f4.jpg";